import React from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { MapWithMarker } from '@erecruit/ui-kit';
import { Resources, AppPermissions } from '@erecruit/types';
import { Intl } from '@erecruit/core';
import { Authorize } from '@erecruit/modules';

import SectionContextMenu from '../SectionContextMenu';
import { BaseSectionProps } from '../../types';
import { useAppConfig } from '../../../../appConfig';

const { FormattedMessage } = Intl;

export default ({
  data,
  expanded,
  isMyOwn,
  onEdit,
}: BaseSectionProps<Resources.PositionLocation>) => {
  const {
    facilityDepartments,
    latitude,
    longitude,
    workFromHome,
    worksiteAddress,
  } = data;

  const appConfig = useAppConfig();

  return (
    <FlexItem>
      <CardInfo
        showDetails={expanded}
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.positionRecord.location.title}
            />
          </H3>
        }
        config={{ translations: { yes: 'Yes', no: 'No' } }}
        extra={
          <Authorize
            permission={`(${AppPermissions.EditPositions} | (${AppPermissions.EditMyOwnPositions} & ${isMyOwn})) & ${AppPermissions.EditPositionLocation}`}
          >
            <SectionContextMenu section="location" onEdit={onEdit} />
          </Authorize>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.location.facilityDepartments}
            />
          }
          type={CardInfoValueType.MultiSelect}
          value={
            facilityDepartments.length > 0
              ? facilityDepartments?.map(({ name }) => name)
              : '-'
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.location.worksiteAddress}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={worksiteAddress?.name}
        />
        {expanded && latitude && longitude ? (
          <CardInfoItem
            type={CardInfoValueType.Custom}
            isDetail
            value={
              <MapWithMarker
                googleMapsKey={appConfig?.REACT_APP_GOOGLE_MAPS_KEY || ''}
                lat={latitude}
                lng={longitude}
              />
            }
          />
        ) : null}
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.location.workFromHome}
            />
          }
          type={CardInfoValueType.Boolean}
          value={workFromHome}
        />
      </CardInfo>
    </FlexItem>
  );
};
